import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationService } from './features/notifications/services/notification.service';
import { AlertMessage, EventMessageBusService } from './core/services/event-message-bus.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'AFSA Back Office';
  public messages: AlertMessage[] = [];

  constructor(
    private notificationService: NotificationService,
    private messageBus: EventMessageBusService
  ) {}

  ngOnInit(): void {
    this.messageBus.newMessagePosted$.subscribe((message => {
        this.messages.push(message); 
    }));
    this.messageBus.messageTimeout$.subscribe(({id}) => {
        const index = this.messages.findIndex((msg) => msg.id === id);
        this.messages.splice(index, 1);
    });
  }

  ngOnDestroy(): void {}
}
